import type { NameNode } from 'graphql';
import { Kind } from 'graphql';

export const createNameNode = (value: string): NameNode => ({
  kind: Kind.NAME,
  value,
});
